import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';

import { DiagnosisTreatmentSearch } from '@nrwl/rx-models';

import { State } from './diagnosis-treatments.state';

export const selectState: MemoizedSelector<object, State> =
  createFeatureSelector<State>('diagnosis-treatments');

export const getState = createSelector(selectState, (state) => state);

export const getDiagnosis = createSelector(selectState, (state, props = null) => {
  if (state.diagnosis) {
    if (state.search.keyword) {
      if (DiagnosisTreatmentSearch.diagnosis === props.searchType) {
        return state.diagnosis.filter(
          (item: any) => item.name.toLowerCase().indexOf(state.search.keyword.toLowerCase()) !== -1,
        );
      }
    }
    return state.diagnosis;
  }
  return null;
});

export const getSurgeons = createSelector(selectState, (state, props = null) => {
  if (state.surgeons) {
    if (state.search.keyword) {
      if (DiagnosisTreatmentSearch.surgeon === props.searchType) {
        return state.surgeons.filter((item: any) =>
          item.name.toLowerCase().includes(state.search.keyword.toLowerCase()),
        );
      }
    }
    return state.surgeons;
  }
  return null;
});

export const getVisits = createSelector(selectState, (state, props = null) => {
  if (state.visitTypes) {
    if (state.search.keyword) {
      if (DiagnosisTreatmentSearch.visit_types === props.searchType) {
        return state.visitTypes.filter((item: any) =>
          item.name.toLowerCase().includes(state.search.keyword.toLowerCase()),
        );
      }
    }
    return state.visitTypes;
  }
  return null;
});

export const getProcedures = createSelector(selectState, (state, props = null) => {
  if (state.procedureTypes) {
    if (state.search.keyword && DiagnosisTreatmentSearch.procedure_types === props.searchType) {
      return state.procedureTypes.filter((item: any) =>
        item.name.toLowerCase().includes(state.search.keyword.toLowerCase()),
      );
    }
    return state.procedureTypes;
  }
  return null;
});

export const getAreaImplants = createSelector(selectState, (state, props = null) => {
  if (state.areaImplants) {
    if (state.search.keyword && DiagnosisTreatmentSearch.area === props.searchType) {
      return state.areaImplants.filter((item: any) =>
        item.name.toLowerCase().includes(state.search.keyword.toLowerCase()),
      );
    }
    return state.areaImplants;
  }
  return null;
});

export const getBodyParts = createSelector(selectState, (state, props = null) => {
  if (state.bodyParts) {
    if (state.search.keyword && DiagnosisTreatmentSearch.body_part === props.searchType) {
      return state.bodyParts.filter((item: any) =>
        item.name.toLowerCase().includes(state.search.keyword.toLowerCase()),
      );
    }

    return state.bodyParts;
  }
  return null;
});

export const getTreatments = createSelector(selectState, (state, props = null) => {
  if (state.treatments) {
    if (state.search.keyword) {
      if (DiagnosisTreatmentSearch.treatment === props.searchType) {
        return state.treatments.filter(
          (item: any) => item.name.toLowerCase().indexOf(state.search.keyword.toLowerCase()) !== -1,
        );
      }
    }
    return state.treatments;
  }
  return null;
});

export const getSelectedTreatments = createSelector(selectState, (state) => {
  if (state.treatments) {
    return state.treatments.filter((item: any) => item.selected);
  }
  return null;
});

export const getSelectedDiagnosis = createSelector(selectState, (state) => {
  if (state.diagnosis) {
    return state.diagnosis.filter((item: any) => item.selected);
  }
  return null;
});

export const getFormTitles = createSelector(selectState, (state) => state.formTitle);

export const getFormProviders = createSelector(selectState, (state) => state.formProviders);

export const getImplantVolumes = createSelector(selectState, (state) => state.implantVolumes);

export const getImplantPlanes = createSelector(selectState, (state) => state.implantPlanes);

export const getBMIData = createSelector(selectState, (state) => state.bmiData);

export const getSkinToneData = createSelector(selectState, (state) => state.skinToneData);
